__turbopack_context__.v({
  "author": "BoltXPlenty-module-scss-module__yjOipa__author",
  "avatar": "BoltXPlenty-module-scss-module__yjOipa__avatar",
  "desc": "BoltXPlenty-module-scss-module__yjOipa__desc",
  "disclaimer": "BoltXPlenty-module-scss-module__yjOipa__disclaimer",
  "heading": "BoltXPlenty-module-scss-module__yjOipa__heading",
  "location": "BoltXPlenty-module-scss-module__yjOipa__location",
  "shares-content": "BoltXPlenty-module-scss-module__yjOipa__shares-content",
  "testimonial": "BoltXPlenty-module-scss-module__yjOipa__testimonial",
  "testimonial-caption": "BoltXPlenty-module-scss-module__yjOipa__testimonial-caption",
  "testimonial-heading": "BoltXPlenty-module-scss-module__yjOipa__testimonial-heading",
  "testimonial-slide": "BoltXPlenty-module-scss-module__yjOipa__testimonial-slide",
});
